var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdduser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "10.93 9.65 154.07 143.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 82.91462,
    cy: 67.97319,
    r: 23.9354
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.04027,70.56566a37.56235,37.56235,0,0,1-5.7839-.44715A62.44982,62.44982,0,0,1,124.8325,127.71l-.12933-.05033c-1.16918-24.555-23.84361-33.82006-25.23786-34.36688a27.27881,27.27881,0,0,1-33.17871-.05454s-24.26586,9.1265-25.381,34.582A62.464,62.464,0,0,1,113.29284,26.96734a37.0103,37.0103,0,0,1,2.40017-8.20917A70.84107,70.84107,0,1,0,153.61531,81.5a71.75423,71.75423,0,0,0-.85376-11.03373Q151.41338,70.56356,150.04027,70.56566Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "164 32.529 147.389 32.529 147.389 15.918 139.072 15.918 139.072 32.529 122.461 32.529 122.461 40.846 139.072 40.846 139.072 57.457 147.389 57.457 147.389 40.846 164 40.846 164 32.529"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdduser);
export default __webpack_public_path__ + "static/media/icon_adduser.8bbf8cf6e654f7d55eaa2a56ef418947.svg";
export { ForwardRef as ReactComponent };